import HttpClientRequest from "../api/client-request";
import { HttpResponse } from "../types";
import { User } from "../context/auth-context";

export interface AnalyticsConfig {
  app: string;
  baseURL: string;
}

export interface PageViewData {
  sessionId: string;
  path: string;
  title: string;
  referrer: string;
  timestamp: string;
  storeSection?: string;
  deviceType?: string;
  utm?: Record<string, string>;
  userId?: number;
  userType: "guest" | "customer";
}

export interface EventData {
  sessionId: string;
  eventType: string;
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
  eventValue?: string;
  pageUrl?: string;
  timestamp: string;
  userId?: number;
  userType: "guest" | "customer";
}

const STORE_FRONT_CONFIG: AnalyticsConfig = {
  app: "store-front",
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/analytics`,
};

export default class AnalyticsService {
  static async trackPageView(
    data: PageViewData,
    requestId?: string
  ): Promise<HttpResponse> {
    try {
      const response = await HttpClientRequest.doPostRequest(
        `${STORE_FRONT_CONFIG.baseURL}/track/pageview`,
        data,
        {
          "Content-Type": "application/json",
        },
        requestId
      );

      return response;
    } catch (error) {
      requestId && HttpClientRequest.cancelRequest(requestId);
      console.error("Error tracking page view:", error);
      return {
        status: 503,
        data: [],
        message: (error as Error).message,
        isCanceled: true,
      };
    }
  }

  static async trackEvent(
    data: EventData,
    requestId?: string
  ): Promise<HttpResponse> {
    try {
      const response = await HttpClientRequest.doPostRequest(
        `${STORE_FRONT_CONFIG.baseURL}/track/event`,
        data,
        {
          "Content-Type": "application/json",
        },
        requestId
      );

      return response;
    } catch (error) {
      requestId && HttpClientRequest.cancelRequest(requestId);
      console.error("Error tracking event:", error);
      return {
        status: 503,
        data: [],
        message: (error as Error).message,
        isCanceled: true,
      };
    }
  }
}
